<div>
	<div class=" font-bold text-[#3c3c3c] mb-2 capitalize">
		Quantity ({{unit.toLowerCase()}})
	</div>
	<div class="quantity-wrapper">
		<button (click)="decrement()" class="left">–</button>

		<input
			#quantityInputPreOrder
			type="number"
			[value]="quantity"
			(change)="onInputChange($event)"
			[min]="minOrderQuantity"
		/>
		<button (click)="increment()" class="right">+</button>

		<span class="total-text">
			Minimum order quantity is {{minOrderQuantity}} {{unit.toLowerCase()}}
		  </span>
	</div>
	<div *ngIf="showMinOrderQuantityMessage" class="fb-warn">
		Minimum order quantity is {{minOrderQuantity}} {{unit.toLowerCase()}}
	</div>
</div>
